import { render, staticRenderFns } from "./QuotationFormTerm.vue?vue&type=template&id=487e26c0&"
import script from "./QuotationFormTerm.vue?vue&type=script&lang=js&"
export * from "./QuotationFormTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487e26c0')) {
      api.createRecord('487e26c0', component.options)
    } else {
      api.reload('487e26c0', component.options)
    }
    module.hot.accept("./QuotationFormTerm.vue?vue&type=template&id=487e26c0&", function () {
      api.rerender('487e26c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/RequestAQuote/QuotationForm/QuotationFormTerm.vue"
export default component.exports